import React from 'react';
import EducationReportView from './reports/EducationReportView';

/**
 * Eğitim Yönetimi (Tailwind): the SMO's view of training. The employees
 * working on a project in the centers the signed-in user is SMO of, with the
 * same real SOP / training completion as Eğitim Raporları (the old page
 * showed a made-up status per row). Screen: EducationReportView.
 */
const EducationManagementPage = () => <EducationReportView mode="smo" />;

export default EducationManagementPage;
